/**
 * 4-H jump height calculation.
 *
 * 4-H Agility and Rally Obedience classes are divided into four jump
 * heights based on the dog's measured height at the withers:
 *
 *   4"  class - dogs up to 10" at the shoulder
 *   8"  class - dogs greater than 10" and up to 14" at the shoulder
 *   12" class - dogs greater than 14" and up to 18" at the shoulder
 *   16" class - dogs measuring over 18" at the shoulder
 *
 * Unlike AKC/UKC, 4-H does not collect a pre-set jump height on the dog's
 * club registration - it is derived on the fly from `height_at_withers`,
 * which is required at registration for 4-H Agility and Rally Obedience.
 */
export function getFhJumpHeight(
  heightAtWithers?: number
): number | undefined {
  if (heightAtWithers === undefined || heightAtWithers === null) {
    return undefined;
  }

  if (heightAtWithers <= 10) return 4;
  if (heightAtWithers <= 14) return 8;
  if (heightAtWithers <= 18) return 12;
  return 16;
}
